import React from 'react'
import { Icon } from 'components'

const DropdownIndicator = props => {
	const { innerProps, innerRef } = props

	return (
		<div ref={innerRef} {...innerProps}>
			<Icon name="arrow-down" />
		</div>
	)
}

export default DropdownIndicator
